export function request(userId, bet) {
    return {
        type: 'BETSLIP_ADD_SPLIT_BET',
        userId,
        bet
    };
}
